/* ARRAY - product page, mobile conversion pass. 12 Oct 2026.
   The marketers' proposal (Nykaa x FAE Beauty reference), points 2, 4, 5 and 6:
     2  STICKY ADD TO BAG (phones): a bar fixed to the bottom that shows the photo, the price and
        the chosen option beside the button, whenever the page's own Add to Bag is off screen.
        It does not add anything itself - it clicks the real button, so quantity, variant, the
        ritual card and the drawer all behave exactly as before.
     4  PACK SAVINGS: under each pack option ("6 PAIRS", "28 PAIRS") the real saving per unit
        against the smallest pack, from the live variant prices. Only on single-option products
        whose every value starts with a count or size in the same unit; rounded DOWN so it never
        overstates; under 5% is not shown.
     5  RATING UNDER THE TITLE (phones): a copy of the price-row stars is placed under the title.
        It only becomes tappable when a real review widget is on the page (none today - the stars
        are the section's placeholder), so it never jumps to nothing.
     6  REWARDS BUTTON (phones, product pages): icon-only and lifted above the sticky bar; the
        review/sale popper is lifted too. CSS in beyondads-pdp-mobile.css, keyed on
        html.has-pdp-sticky / html.pdp-sticky-on set here.
   Loaded from snippets/beyondads-rewards-launcher.liquid on product templates only. Built from
   the rendered page so sections/beyondads-pdp.liquid is unchanged. */
(function () {
  'use strict';
  if (window.__pdpMob) return;
  window.__pdpMob = true;

  var html = document.documentElement;
  var MQ = window.matchMedia('(max-width: 749px)');

  /* ---------- 5. rating under the title ---------- */
  function stars(root) {
    var s = root.querySelector('.pdp-meta .pdp-stars');
    var head = root.querySelector('.pdp-head');
    if (!s || !head || head.querySelector('.pdp-stars--top')) return;
    var c = s.cloneNode(true);
    c.classList.add('pdp-stars--top');
    head.appendChild(c);
    var target = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, #shopify-product-reviews, [data-reviews-anchor]');
    if (!target) return;
    c.classList.add('is-link');
    c.setAttribute('role', 'link');
    c.tabIndex = 0;
    function go() { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    c.addEventListener('click', go);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
  }

  /* ---------- 4. saving under each pack option ---------- */
  var UNIT = /^\s*(\d+(?:[.,]\d+)?)\s*(?:x\s*)?(pairs?|pcs?|pieces?|packs?|sachets?|masks?|sheets?|patch(?:es)?|pads?|units?|capsules?|caps|tablets?|tabs|softgels?|gummies|bars?|ml|g|gr|oz)\b/i;
  function unitOf(u) {
    u = u.toLowerCase();
    if (/^(pcs?|pieces?)$/.test(u)) return 'pc';
    if (u === 'gr') return 'g';
    if (u === 'gummies') return 'gummy';
    return u.replace(/(es|s)$/, '');
  }
  function qty(v) {
    var m = String(v || '').match(UNIT);
    if (m) return { n: parseFloat(m[1].replace(',', '.')), u: unitOf(m[2]) };
    m = String(v || '').match(/pack of\s*(\d+)/i);
    return m ? { n: +m[1], u: 'pack' } : null;
  }
  function savings(root) {
    var el = root.querySelector('[data-pdp-variants]');
    var row = root.querySelector('.pdp-swatches--pill[data-pdp-opt="0"]');
    if (!el || !row) return;
    var vs;
    try { vs = JSON.parse(el.textContent); } catch (e) { return; }
    if (!vs || vs.length < 2) return;
    var info = {}, unit = null, base = null, sizes = {};
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.option2 != null && v.option2 !== '') return;           /* single-option products only */
      var q = qty(v.option1);
      if (!q || !q.n || !v.price) return;
      if (unit && q.u !== unit) return;
      unit = q.u;
      var per = v.price / q.n;
      info[v.option1] = { n: q.n, per: per };
      sizes[q.n] = 1;
      if (!base || q.n < base.n) base = { n: q.n, per: per };
    }
    if (Object.keys(sizes).length < 2) return;
    [].forEach.call(row.querySelectorAll('.pdp-pill[data-pdp-val]'), function (b) {
      var it = info[b.getAttribute('data-pdp-val')];
      if (!it || it.n === base.n || b.querySelector('.pdp-pill-save')) return;
      var pct = Math.floor((1 - it.per / base.per) * 100);
      if (pct < 5) return;
      var sp = document.createElement('span');
      sp.className = 'pdp-pill-save';
      sp.textContent = 'Save ' + pct + '%';
      b.appendChild(sp);
      b.classList.add('has-save');
    });
  }

  /* ---------- 2 + 6. sticky Add to Bag ---------- */
  function sticky(root, add) {
    var bar = document.createElement('div');
    bar.className = 'pdp-sticky';
    bar.setAttribute('data-pdp-sticky', '');
    bar.innerHTML = '<img class="pdp-sticky-img" alt="" width="44" height="44" decoding="async">' +
      '<span class="pdp-sticky-t"><b class="pdp-sticky-p"></b><span class="pdp-sticky-v"></span></span>' +
      '<button type="button" class="pdp-sticky-add"></button>';
    document.body.appendChild(bar);
    var bImg = bar.querySelector('img'), bP = bar.querySelector('.pdp-sticky-p'),
        bV = bar.querySelector('.pdp-sticky-v'), bBtn = bar.querySelector('button');
    html.classList.add('has-pdp-sticky');

    function sync() {
      var main = root.querySelector('[data-pdp-main]');
      var src = main && (main.currentSrc || main.src);
      if (src && bImg.getAttribute('src') !== src) bImg.src = src;
      var p = root.querySelector('[data-pdp-add-p]');
      bP.textContent = p ? p.textContent.trim() : '';
      var names = [].map.call(root.querySelectorAll('[data-pdp-opt-name]'), function (e) { return e.textContent.trim(); })
        .filter(Boolean);
      bV.textContent = names.join(' · ');
      bV.hidden = !names.length;
      var t = root.querySelector('[data-pdp-add-t]');
      bBtn.textContent = t ? t.textContent.trim() : 'ADD TO BAG';
      bBtn.disabled = !!add.disabled;
    }
    var queued = false;
    function later() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; sync(); }); }
    new MutationObserver(later).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'src', 'class'] });
    sync();

    /* The bar is see-through (client): over a dark band (the footer) its dark text would vanish, so
       it reads the colour behind its middle and flips to light text there. */
    function lum(c) {
      var m = c && c.match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      var p = m[1].split(',').map(parseFloat);
      if (p.length > 3 && p[3] < 0.5) return null;
      return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
    }
    function tone() {
      if (!on || !document.elementsFromPoint) return;
      var els = document.elementsFromPoint(window.innerWidth / 2, window.innerHeight - 24), L = null;
      for (var i = 0; i < els.length && L === null; i++) {
        if (bar.contains(els[i])) continue;
        for (var n = els[i]; n && n.nodeType === 1 && L === null; n = n.parentElement) L = lum(getComputedStyle(n).backgroundColor);
      }
      bar.classList.toggle('is-dark', L !== null && L < 0.45);
    }

    var on = false;
    function check() {
      var want = false;
      if (MQ.matches) {
        var r = add.getBoundingClientRect();
        var visible = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight - 76;
        want = !visible;
      }
      if (want === on) return;
      on = want;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      html.classList.toggle('pdp-sticky-on', on);
    }
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; check(); tone(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (MQ.addEventListener) MQ.addEventListener('change', onScroll); else if (MQ.addListener) MQ.addListener(onScroll);
    check();
    setTimeout(function () { check(); tone(); }, 600);

    bBtn.addEventListener('click', function () { if (!add.disabled) add.click(); });
  }

  function init() {
    var root = document.querySelector('[data-pdp-root]');
    if (!root) return;
    stars(root);
    savings(root);
    var add = root.querySelector('[data-pdp-add]');
    if (add) sticky(root, add);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
